module.exports = __webpack_public_path__ + "static/media/bar_graph.02158214.svg";